import { createApp } from 'vue';
import Antd from 'ant-design-vue';
import App from './App.vue';
import router from './router';
import pinia from './store';
import { useUserStore } from './store/modules/user'; 
// import { permissionDirective, roleDirective } from './utils/permission';
import permission from './directives/permission';
import 'ant-design-vue/dist/reset.css';
import './styles/base.css';
// import zhCN from 'ant-design-vue/es/locale/zh_CN';

import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
dayjs.locale('zh-cn'); // 全局使用简体中文


// ==================== 抑制 ResizeObserver 错误 ====================

// 1. 拦截 window.error 事件
window.addEventListener('error', (e) => {
  if (e.message && e.message.includes('ResizeObserver loop')) {
    e.stopImmediatePropagation();
    return false;
  }
});

// 2. 拦截 unhandledrejection 事件
window.addEventListener('unhandledrejection', (e) => {
  if (e.reason && e.reason.message && e.reason.message.includes('ResizeObserver loop')) {
    e.stopImmediatePropagation();
    return false;
  }
});

// 3. 重写 console.error
const originalConsoleError = console.error;
console.error = function(...args) {
  if (args[0] && typeof args[0] === 'string' && args[0].includes('ResizeObserver loop')) {
    return;
  }
  originalConsoleError.apply(console, args);
};

// 4. 重写 console.warn
const originalConsoleWarn = console.warn;
console.warn = function(...args) {
  if (args[0] && typeof args[0] === 'string' && args[0].includes('ResizeObserver loop')) {
    return;
  }
  originalConsoleWarn.apply(console, args);
};

// ==================== 应用初始化 ====================

const app = createApp(App);

// 注册全局权限指令
app.directive('permission', permission);
// app.directive('role', roleDirective);
// app.directive('auth', permission); // 新的权限指令，直接从缓存读取

app.use(Antd)
   .use(router)
   .use(pinia);

// 👇 关键：在 mount 之前恢复用户状态
const initApp = async () => {
  const userStore = useUserStore();

  // 如果 localStorage 里有 token，尝试自动登录
  if (localStorage.getItem('token')) {
    try {
      await userStore.fetchUserInfo(); // 确保这个 action 存在并返回 Promise
      console.log('User info fetched successfully:', userStore.userInfo);
      
    } catch (error) {
      // 可选：如果 token 无效，清除它（避免下次再试）
      console.warn('Auto fetch user info failed, clearing token:', error);
      userStore.logout(); // 假设你有 logout 方法
    }
  }

  // 挂载应用
  app.mount('#app');
};

// console.log('process.env.VUE_APP_API_BASE_URL', process.env.VUE_APP_API_BASE_URL)

// 启动
initApp();
